(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearControlContributorNewController", LebaniegoYearControlContributorNewController);

    LebaniegoYearControlContributorNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "$http",
        "$state",
        "$mdSidenav",
        "$q",
        "entity",
        "LebaniegoYearControlContributor",
        "previousState",
        "toastr",
        "DateUtils",
    ]

    function LebaniegoYearControlContributorNewController(
        $rootScope,
        $timeout,
        $scope,
        $http,
        $state,
        $mdSidenav,
        $q,
        entity,
        LebaniegoYearControlContributor,
        previousState,
        toastr,
        DateUtils
    ) {
        var vm = this;

        vm.lebaniegoYearControlContributor = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        // Retrieve the value(s)
        vm.searchItem = JSON.parse(
            localStorage.getItem("searchLebaniegoYearControlContributorParameters")
        );
        
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearControlContributor = Object.assign({}, vm.lebaniegoYearControlContributor);
            lebaniegoYearControlContributor.id = null;
            lebaniegoYearControlContributor.year = vm.lebaniegoYearControlContributor.year;
            lebaniegoYearControlContributor.sector = 'APORTANTE';
            vm.lebaniegoYearControlContributor.gFile = {
                id: vm.lebaniegoYearControlContributor.gFile
            };
            lebaniegoYearControlContributor.gFile = vm.lebaniegoYearControlContributor.gFile;
            LebaniegoYearControlContributor.save(lebaniegoYearControlContributor, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-control-contributor", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el aportante");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }

        $scope.query = function(searchText) {
            return $http
            .get('/api/ly-control/g-file/search?searchText=' + searchText + '&jurisdiction=AÑO_LEBANIEGO_APORTANTES')
            .then(function(data) {
                var result = data.data, deferred;
                deferred = $q.defer();
                deferred.resolve(result);
                return result;
            });
        };

        $scope.selectedItemChange = function (item) {
            if (item) {
                vm.lebaniegoYearControlContributor.businessName = item.sectorBusinessName;
                vm.lebaniegoYearControlContributor.gFile = item.gFileId;
            }
        }
    }
})();